import { useEffect } from "react";

export const useDiffStyles = (enabled = true) => {
	useEffect(() => {
		if (enabled) void import("@ext/git/core/Diff/styles/diff.css");
	}, [enabled]);
};
